module.exports = __webpack_public_path__ + "img/business-license.3d161c1f.png";